import React, {useState} from 'react'
import {Row, Col, Alert} from 'reactstrap'
import {Spinner} from 'react-bootstrap'
export default function Modal_Email_Submit({isVisible, onPress, onCancel, isLoading = false}) {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')

  if(isVisible){
    return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', alignSelf: 'center'}}>
      <Col md={12}>
        <div className="pt-5 pb-5 p-4 bg-white rounded shadow">
          {
            isLoading?
              <div className="custom-form mt-4" style={{width: 200, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Spinner animation={'border'} variant={'primary'}/>
              </div>
              :
              <>
                <h4>Please provide an email to download the guide.</h4>
                <div className="custom-form mt-4">
                  <form method="post" onSubmit={(event) => {
                    event.preventDefault()
                    onPress({firstName: firstName, lastName: lastName, email: email})
                  }}  name="contact-form" id="contact-form">
                    <Row>
                      <Col md={12}>
                        <div className="form-group position-relative">
                          <label>First Name <span className="text-danger">*</span></label>
                          <i className="mdi mdi-email ml-3 icons"></i>
                          <input name="firstname" id="firstname" type="text" className="form-control pl-5" placeholder="First Name:" required onChange={(e) => setFirstName(e.target.value)}/>
                        </div>
                        <div className="form-group position-relative">
                          <label>Last name <span className="text-danger">*</span></label>
                          <i className="mdi mdi-email ml-3 icons"></i>
                          <input name="lastname" id="lastname" type="text" className="form-control pl-5" placeholder="Last Name :" required onChange={(e) => setLastName(e.target.value)}/>
                        </div>
                        <div className="form-group position-relative">
                          <label>Your Email <span className="text-danger">*</span></label>
                          <i className="mdi mdi-email ml-3 icons"></i>
                          <input name="email" id="email" type="email" className="form-control pl-5" placeholder="Your email :" required onChange={(e) => setEmail(e.target.value)}/>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} className="text-center">
                        <input type="submit" id="submit" name="send" className="submitBnt btn btn-primary btn-block" value="Download Guide" />
                        <div id="simple-msg"></div>
                      </Col>
                    </Row>
                  </form>
                  <Row>
                    <Col sm={12} className="text-center">
                      <input type="submit" id="cancel" name="cancel" onClick={onCancel} className="submitBnt btn btn-block" value="Cancel" />
                    </Col>
                  </Row>
                </div>
              </>
          }
        </div>
      </Col>
    </div>
  } else {
    return null
  }
}
